import React from 'react';
import classNames from 'classnames';
import { noop } from 'lodash';
import { I18nProvider } from '@fiverr-private/fiverr_context';
import { Tooltip } from '@fiverr-private/fit';
import { Tooltip as PentaTooltip } from '@fiverr-private/tooltip';
import { EnvelopeIcon, BellIcon } from '@fiverr-private/visuals';
import { DotIndicator } from '@fiverr-private/data_display';
import { IconButton } from '@fiverr-private/button';
import { TYPES } from '../../NotificationsDrawer/types';
import ButtonMessages from '../ButtonMessages';
import ButtonIcon from '../ButtonIcon';
import * as apps from '../../enums/apps';
import Envelope from './envelope';
import Bell from './bell';

import styles from './style.module.scss';

export const getButtonComponent = ({
    drawerType,
    handleMouseEnter,
    count,
    unreadDotClassName,
    trigger,
    onTriggerClick = noop,
}) => {
    const handleClick = (appName) => (params) => onTriggerClick({ ...params, appName });

    switch (drawerType) {
        case TYPES.NOTIFICATIONS:
            return function togglerFunc(togglerProps) {
                return (
                    <I18nProvider>
                        {({ i18n }) => (
                            <Tooltip
                                containerClassName={styles.popover}
                                content={i18n.t('realtime_notifications.notifications_drawer.notifications')}
                            >
                                <ButtonIcon
                                    {...togglerProps}
                                    content={trigger || <Bell />}
                                    unseenCount={count[apps.APP_NAME_NOTIFICATIONS]}
                                    className={classNames({ 'trigger-notifications': !trigger })}
                                    unreadDotClassName={unreadDotClassName}
                                    handleMouseEnter={handleMouseEnter}
                                    onClick={handleClick(apps.APP_NAME_NOTIFICATIONS)}
                                />
                            </Tooltip>
                        )}
                    </I18nProvider>
                );
            };
        case TYPES.NOTIFICATIONS_MODERN:
            return function togglerFunc({ toggle, isOpen }) {
                const unseenCount = count[apps.APP_NAME_NOTIFICATIONS];

                return (
                    <I18nProvider>
                        {({ i18n }) => (
                            <PentaTooltip
                                // switch to uncontrolled mode for default behaviour but force close if dropdown is open
                                isOpen={isOpen ? false : undefined}
                                content={i18n.t('realtime_notifications.notifications_drawer.notifications')}
                                position="bottom"
                                withDelay
                            >
                                <IconButton
                                    variant="ghost"
                                    onClick={(event) => {
                                        if (!isOpen) {
                                            handleMouseEnter();
                                        }
                                        handleClick(apps.APP_NAME_NOTIFICATIONS)({ isOpen: !isOpen });
                                        toggle(event);
                                    }}
                                    aria-label={i18n.t('realtime_notifications.notifications_drawer.notifications')}
                                >
                                    {unseenCount > 0 && (
                                        <DotIndicator
                                            isOverlay
                                            offset={-2}
                                            position="top-right"
                                            type="special"
                                            size="md"
                                        />
                                    )}
                                    {trigger || <BellIcon size="md" />}
                                </IconButton>
                            </PentaTooltip>
                        )}
                    </I18nProvider>
                );
            };
        case TYPES.MESSAGES:
            return function togglerFunc(togglerProps) {
                return (
                    <I18nProvider>
                        {({ i18n }) => (
                            <Tooltip
                                containerClassName={styles.popover}
                                content={i18n.t('realtime_notifications.notifications_drawer.messages')}
                            >
                                <ButtonIcon
                                    {...togglerProps}
                                    content={trigger || <Envelope />}
                                    unseenCount={count[apps.APP_NAME_INBOX]}
                                    className={classNames({ 'trigger-messages': !trigger })}
                                    unreadDotClassName={unreadDotClassName}
                                    handleMouseEnter={handleMouseEnter}
                                    onClick={handleClick(apps.APP_NAME_INBOX)}
                                />
                            </Tooltip>
                        )}
                    </I18nProvider>
                );
            };
        case TYPES.MESSAGES_MODERN:
            return function togglerFunc({ toggle, isOpen }) {
                const unseenCount = count[apps.APP_NAME_INBOX];

                return (
                    <I18nProvider>
                        {({ i18n }) => (
                            <PentaTooltip
                                // switch to uncontrolled mode for default behaviour but force close if dropdown is open
                                isOpen={isOpen ? false : undefined}
                                content={i18n.t('realtime_notifications.notifications_drawer.messages')}
                                position="bottom"
                                withDelay
                            >
                                <IconButton
                                    variant="ghost"
                                    onClick={(event) => {
                                        if (!isOpen) {
                                            handleMouseEnter();
                                        }
                                        handleClick(apps.APP_NAME_INBOX)({ isOpen: !isOpen });
                                        toggle(event);
                                    }}
                                    aria-label={i18n.t('realtime_notifications.notifications_drawer.messages')}
                                >
                                    {unseenCount > 0 && (
                                        <DotIndicator
                                            isOverlay
                                            offset={-2}
                                            position="top-right"
                                            type="special"
                                            size="md"
                                        />
                                    )}
                                    {trigger || <EnvelopeIcon size="md" />}
                                </IconButton>
                            </PentaTooltip>
                        )}
                    </I18nProvider>
                );
            };
        case TYPES.BOTH:
        default:
            return function togglerFunc(togglerProps) {
                return <ButtonMessages {...togglerProps} handleMouseEnter={handleMouseEnter} />;
            };
    }
};
